import * as React from 'react'
import ActionButtons from '../../components/shared/Store/ActionButton/ActionButtons'
import { AnimatedContainer } from '../../components/shared/Store/StoreAnimationComponents'
import Baner from '../../components/shared/Store/Baner/Baner'
import { Col, Container } from 'reactstrap'
import {
  StoreButtons,
  StoreDetailsGrid,
  StoreHeader,
  StoreHeaderRow,
  StoreInfoClaim,
  StoreName
} from '../../components/shared/Store/StoreStyledComponents'
import Store from 'api/models/Store'

interface Props {
  loaded: boolean,
  isMobile: boolean,
  isZeroTouch: boolean,
  actionButtonsToggled: boolean,
  activeStore: Store,
  storeTheme: object,
  toggleShareModal: (toggled: boolean) => void,
  onToggle: (toggled: boolean) => void,
}

export default function StoreViewHeader({
  loaded,
  isMobile,
  actionButtonsToggled,
  activeStore,
  storeTheme,
  toggleShareModal,
  onToggle,
  isZeroTouch
}: Props) {
  const pose = storeTheme && loaded ? 'visible' : 'visible'
  const bannerProps = {
    bannerImage: activeStore.getBanner()
  }
  return (
    <StoreHeader
      modalopen={!isMobile && actionButtonsToggled}
    >
      <Container>
        <StoreHeaderRow>
          <Col
            xs={{ size: '12' }}
            sm={{ size: 6 }}
            lg={{ size: 6 }}
            xl={{ size: 5, offset: 1 }}
          >
            <AnimatedContainer
              delay={100}
              initialPose={'hidden'}
              pose={pose}
            >
              <Baner {...bannerProps} />
            </AnimatedContainer>
          </Col>
          <Col
            xs={{ size: '12' }}
            sm={{ size: 6 }}
            lg={{ size: 6 }}
            xl={{ size: 5 }}
          >
            <StoreDetailsGrid>
              <StoreName>
                <AnimatedContainer
                  delay={200}
                  initialPose={'hidden'}
                  pose={pose}
                >
                  {activeStore.getName()}
                </AnimatedContainer>
              </StoreName>
              <StoreInfoClaim>
                <AnimatedContainer
                  delay={200}
                  initialPose={'hidden'}
                  pose={pose}
                >
                  {activeStore.getDescription()}
                </AnimatedContainer>
              </StoreInfoClaim>
              <StoreButtons>
                <AnimatedContainer
                  delay={300}
                  initialPose={'hidden'}
                  pose={pose}
                >
                  {activeStore.getShortId() && !isMobile && (
                    <ActionButtons
                      toggleShareModal={toggleShareModal}
                      onToggle={onToggle}
                      isZeroTouch={isZeroTouch}
                    />
                  )}
                </AnimatedContainer>
              </StoreButtons>
            </StoreDetailsGrid>
          </Col>
        </StoreHeaderRow>
      </Container>
    </StoreHeader>
  )
}